

export const LongerPagraphsShimmerLoader = () => {
    return (
        <div className="border border-blue-200 shadow rounded-md p-4 w-full mx-auto h-full">
            <div role="status" className="space-y-6 animate-pulse">
                <div className="flex items-center w-full">
                    <div className="h-2.5 bg-slate-200 rounded-full w-32"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-24"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-full"></div>
                </div>
                <div className="flex items-center w-full ">
                    <div className="h-2.5 bg-slate-200 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-24"></div>
                </div>
                <div className="flex items-center w-full ">
                    <div className="h-2.5 bg-slate-300 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-200 rounded-full w-80"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-full"></div>
                </div>
                <div className="flex items-center w-full ">
                    <div className="h-2.5 ms-2 bg-slate-200 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-24"></div>
                </div>
                <div className="flex items-center w-full">
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-32"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-24"></div>
                    <div className="h-2.5 ms-2 bg-slate-200 rounded-full w-full"></div>
                </div>
                <div className="flex items-center w-full">
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-200 rounded-full w-80"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-full"></div>
                </div>
            </div>
        </div>
    )
}

export const ProfileDetailsShimmerLoader = () => {
    return (
        <div className="border border-blue-200 shadow rounded-md p-4 w-full mx-auto">
            <div className="animate-pulse flex space-x-4">
                <div className="flex-1 space-y-6 py-1">
                    <div className="h-2 bg-slate-200 rounded"></div>
                    <div className="space-y-3">
                        <div className="grid grid-cols-3 gap-4">
                            <div className="h-2 bg-slate-200 rounded col-span-2"></div>
                            <div className="h-2 bg-slate-300 rounded col-span-1"></div>
                        </div>
                        <div className="h-2 bg-slate-200 rounded"></div>
                    </div>
                    <div className="space-y-3">
                        <div className="grid grid-cols-3 gap-4">
                            <div className="h-2 bg-slate-300 rounded col-span-2"></div>
                            <div className="h-2 bg-slate-200 rounded col-span-1"></div>
                        </div>
                        <div className="h-2 bg-slate-200 rounded"></div>
                    </div>
                </div>
                <div className="rounded-full bg-slate-200 h-32 w-32"></div>
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    )
}

export const MediumPagraphsShimmerLoader = () => {
    return (
        <div className="border border-blue-200 shadow rounded-md p-4 w-full mx-auto h-full">
            <div role="status" className="space-y-6 animate-pulse">
                <div className="flex items-center w-full">
                    <div className="h-2.5 bg-slate-200 rounded-full w-32"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-24"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-full"></div>
                </div>
                <div className="flex items-center w-full ">
                    <div className="h-2.5 bg-slate-200 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-24"></div>
                </div>
                <div className="flex items-center w-full ">
                    <div className="h-2.5 bg-slate-300 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-200 rounded-full w-80"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-full"></div>
                </div>
                <div className="flex items-center w-full ">
                    <div className="h-2.5 ms-2 bg-slate-200 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-full"></div>
                    <div className="h-2.5 ms-2 bg-slate-300 rounded-full w-24"></div>
                </div>
            </div>
        </div>
    )
}

export const AboutDetailsShimmerLoader = () => {
    return (
        <div className="border border-blue-200 shadow rounded-md p-4 w-full mx-auto">
            <div role="status" className="animate-pulse">
                <div className="h-2.5 bg-slate-300 rounded-full mb-2.5 mx-auto"></div>
                <div className="flex items-center justify-center mt-4">
                    <div className="w-28 h-2.5 bg-slate-200 rounded-full me-3 mb-2.5"></div>
                    <div className="h-2.5 mx-auto bg-slate-300 rounded-full w-[800px] mb-2.5"></div>
                    <div className="w-28 h-2.5 bg-slate-200 rounded-full mb-2.5"></div>
                </div>
                <div className="h-2.5 bg-slate-300 rounded-full mx-auto"></div>
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    )
}

export const SingleBlogDetails = () => {
    return (
<>
<div class="animate-pulse flex flex-col space-y-6 p-6  mx-auto  2xl:mx-24 xl:mx-40 lg:mx-40 md:mx-20 sm:mx-10  mt-28 mb-10">
  <div class="h-64 bg-slate-200 rounded-lg w-full"></div>
  <div class="space-y-4">
    <div class="h-8 bg-slate-200 rounded w-5/6"></div>
  </div>

  <div class="space-y-4">
  <div class="border border-blue-200 shadow rounded-md p-4 w-1/3">
  <div class="animate-pulse flex space-x-4">
    <div class="rounded-full bg-slate-200 h-10 w-10"></div>
    <div class="flex-1 space-y-6 py-1">
      <div class="h-2 bg-slate-200 rounded"></div>
      <div class="space-y-3">
        <div class="grid grid-cols-3 gap-4">
          <div class="h-2 bg-slate-200 rounded col-span-2"></div>
          <div class="h-2 bg-slate-200 rounded col-span-1"></div>
        </div>
    
      </div>
    </div>
  </div>
</div>
  </div>


  <div class="space-y-4">
    <div class="h-4 bg-slate-200 rounded w-5/6"></div>
    <div class="h-4 bg-slate-200 rounded w-2/3"></div>
    <div class="h-4 bg-slate-200 rounded w-full"></div>
    <div class="h-4 bg-slate-200 rounded w-4/5"></div>
    <div class="h-4 bg-slate-200 rounded w-3/4"></div>
    <div class="h-4 bg-slate-200 rounded w-full"></div>
  </div>


  <div class="h-1 bg-slate-200 rounded w-full"></div>


  <div class="space-y-4">
    <div class="h-4 bg-slate-200 rounded w-4/5"></div>
    <div class="h-4 bg-slate-200 rounded w-3/5"></div>
    <div class="h-4 bg-slate-200 rounded w-2/3"></div>
    <div class="h-4 bg-slate-200 rounded w-full"></div>
    <div class="h-4 bg-slate-200 rounded w-5/6"></div>
  </div>

  <div class="flex justify-between mt-6 space-x-4">
  <div class="bg-slate-200 h-64 w-1/3 rounded"></div>
  <div class="bg-slate-200 h-64 w-1/3 rounded"></div>
  <div class="bg-slate-200 h-64 w-1/3 rounded"></div>
</div>



  <div class="flex justify-between mt-6">
    <div class="h-10 bg-slate-200 rounded w-24"></div>
    <div class="h-10 bg-slate-200 rounded w-36"></div>
  </div>




</div>


</>
        
        
    )
}

export const LastBlogDetails = () => {
    return (
<>
<div class="animate-pulse flex flex-col space-y-6 p-6  mx-auto  2xl:mx-24 xl:mx-40 lg:mx-40 md:mx-20 sm:mx-10  mt-28 mb-10">
  <div class="h-64 bg-slate-200 rounded-lg w-full"></div>
  <div class="space-y-4">
    <div class="h-8 bg-slate-200 rounded w-5/6"></div>
  </div>

  <div class="space-y-4">
  <div class="border border-blue-200 shadow rounded-md p-4 w-1/3">
  <div class="animate-pulse flex space-x-4">
    <div class="rounded-full bg-slate-200 h-10 w-10"></div>
    <div class="flex-1 space-y-6 py-1">
      <div class="h-2 bg-slate-200 rounded"></div>
      <div class="space-y-3">
        <div class="grid grid-cols-3 gap-4">
          <div class="h-2 bg-slate-200 rounded col-span-2"></div>
          <div class="h-2 bg-slate-200 rounded col-span-1"></div>
        </div>
    
      </div>
    </div>
  </div>
</div>
  </div>
  <div class="flex justify-between mt-6">
    <div class="h-10 bg-slate-200 rounded w-24"></div>
    <div class="h-10 bg-slate-200 rounded w-36"></div>
  </div>
</div>

</>
        
        
    )
}

export const ShortBlogDetails = () => {
    return (
<>
<div class="animate-pulse flex flex-col space-y-6 p-6  mx-auto  2xl:mx-24 xl:mx-40 lg:mx-40 md:mx-20 sm:mx-10  mt-28 mb-10">
  <div class="h-64 bg-slate-200 rounded-lg w-full"></div>
  <div class="space-y-4">
    <div class="h-8 bg-slate-200 rounded w-5/6"></div>
  </div>

  <div class="space-y-4">
  <div class="border border-blue-200 shadow rounded-md p-4 w-1/3">
  <div class="animate-pulse flex space-x-4">
    <div class="rounded-full bg-slate-200 h-10 w-10"></div>
    <div class="flex-1 space-y-6 py-1">
      <div class="h-2 bg-slate-200 rounded"></div>
      <div class="space-y-3">
        <div class="grid grid-cols-3 gap-4">
          <div class="h-2 bg-slate-200 rounded col-span-2"></div>
          <div class="h-2 bg-slate-200 rounded col-span-1"></div>
        </div>
    
      </div>
    </div>
  </div>
</div>
  </div>
  <div class="flex justify-between mt-6">
    <div class="h-10 bg-slate-200 rounded w-24"></div>
    <div class="h-10 bg-slate-200 rounded w-36"></div>
  </div>
</div>

</>
        
        
    )
}